import Util from '@/lib/util'
export default [
    {
        title:Util.L('Order'),
        key:'orderNo',
        width: 80,
      },
    {
        title:Util.L('Code'),
        key:'id',
        width: 80,
    },{
        title:Util.L('Name'),
        key:'name',
        width: 150,
    },{
        title:Util.L('ShortName'),
        key:'shortName',
        width: 120,
    },{
        title:Util.L('LicensePlate'),
        key:'licensePlate',
        width: 120,
    },{
        title:Util.L('Type'),
        key:'type',
        width: 80,
        render:(h:any,params:any)=>{
            return h("span", Util.L('TplType'+params.row.type));
        }
    },{
        title:Util.L('Active'),
        key:'isActiveText',
        width: 120,
    },{
        title:Util.L('ContactPhone'),
        key:'contactPhone',
        width: 120,
    },{
        title:Util.L('CreationTime'),
        key:'creationTime',
        width: 170,
        render:(h:any,params:any)=>{
            return h("span", Util.toViewDateString(params.row.creationTime));
        }
    },{
        title: Util.L('Action'),
        width:150,
        fixed:'right',
        slot: 'action',
        align: 'center'
    }]